

// Get All Envois
export const getEnvoisStart = ()=>({
    type: 'GET_ENVOIS_START',
})
export const getEnvoisSuccess = (envois)=>({
    type: 'GET_ENVOIS_SUCCESS',
    payload: envois
})
export const getEnvoisFailure = (error)=>({
    type: 'GET_ENVOIS_FAILURE',
    payload: error
})

// Set Page Number
export const setPageNumberSuccess = (page) =>({
    type: 'SET_PAGE_NUMBER_SUCCESS',
    payload: page,
})

// Get One Envoie
export const getEnvoieStart = ()=>({
    type: 'GET_ENVOIE_START',
})
export const getEnvoieSuccess = (envoie)=>({
    type: 'GET_ENVOIE_SUCCESS',
    payload: envoie
})
export const getEnvoieFailure = (error)=>({
    type: 'GET_ENVOIE_FAILURE',
    payload: error
})

// Add One Case
export const addCaseStart = ()=>({
    type: 'ADD_CASE_START',
})
export const addCaseSuccess = (historyCase)=>({
    type: 'ADD_CASE_SUCCESS',
    payload: historyCase
})
export const addCaseFailure = (error)=>({
    type: 'ADD_CASE_FAILURE',
    payload: error
})